import consumer from "./consumer";

document.addEventListener("DOMContentLoaded", function () {
  console.log("[DEBUG] DOMContentLoaded triggered");

  const urlMatch = window.location.pathname.match(/consultations\/(\d+)/);
  const consultationId = urlMatch ? urlMatch[1] : null;
  if (!consultationId) {
    console.warn("[DEBUG] consultationId not found in URL — skipping subscription");
    return;
  }

  const role = window.location.pathname.includes("/cabinet/") ? "cabinet" :
    window.location.pathname.includes("/tarolog/") ? "tarolog" : "unknown";

  const onlineIndicator = document.getElementById("online-indicator");

  const consultationChannel = consumer.subscriptions.create(
    { channel: "ConsultationChannel", consultation_id: consultationId, role: role },
    {
      connected() {
        console.log(`[DEBUG] Connected as ${role} to ConsultationChannel`);
      },

      disconnected() {
        console.log(`[DEBUG] Disconnected from ConsultationChannel`);
      },

      received(data) {
        console.log("[DEBUG] Received data from channel:", data);

        if (data.type === "typing") {
          const otherRole = role === "cabinet" ? "tarolog" : "cabinet";
          if (data.role === otherRole && onlineIndicator) {
            if (data.typing) {
              onlineIndicator.textContent = "Пише...";
              onlineIndicator.classList.add("typing");
            } else {
              const isOtherOnline = lastStatus[`${otherRole}_online`];
              onlineIndicator.textContent = isOtherOnline ? `онлайн` : `офлайн`;
              onlineIndicator.classList.remove("typing");
            }
          }
          return;
        }

        if (data.type === "status") {
          lastStatus = data;
          const otherRole = role === "cabinet" ? "tarolog" : "cabinet";
          const isOtherOnline = data[`${otherRole}_online`];

          if (onlineIndicator && !onlineIndicator.classList.contains("typing")) {
            onlineIndicator.textContent = isOtherOnline ? `онлайн` : `офлайн`;
            onlineIndicator.classList.toggle("online", isOtherOnline);
            onlineIndicator.classList.toggle("offline", !isOtherOnline);
          }

          // 🔴 Оновлюємо кнопку аудіодзвінка
          const audioCallBtn = document.getElementById("audio-call-start-btn");
          if (audioCallBtn) {
            audioCallBtn.style.display = isOtherOnline ? "block" : "";
          }

          // 🔴 Оновлюємо кнопку перекладу
          const translationBtn = document.getElementById("sendTranslationSignal");
          if (translationBtn) {
            translationBtn.style.display = isOtherOnline ? "block" : "";
          }

          return;
        }


        const messagesContainer = document.getElementById("messages");
        if (!messagesContainer) {
          console.error("[DEBUG] #messages container not found");
          return;
        }

        const newMessage = document.createElement("div");
        newMessage.className = [
          data.user === "user" ? "message__user" : "message__specialist",
          data.audio ? "message__audio" : ""
        ].filter(Boolean).join(" ");

        newMessage.innerHTML = `
          ${data.content}
          <span class="message__time">${data.created_at}</span>
          ${data.image ? `<img src="${data.image}" class="message__image" />` : ''}
          ${data.audio ? `
            <div class="audio-message" id="audio-message-${data.id}">
              <audio class="audio-src" id="audio-${data.id}" src="${data.audio}" style="display:none;"></audio>
              <div id="waveform-${data.id}" class="waveform-audio"></div>
              <div class="audio-message__btn">
                <button class="play-btn" data-id="${data.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                    <circle cx="16" cy="16" r="16" fill="white"/>
                    <polygon points="12,8 24,16 12,24" fill="black"/>
                  </svg>
                </button>
              </div>
            </div>
          ` : ''}
        `;

        messagesContainer.appendChild(newMessage);

        if (data.audio) {
          initWave(data.id);
        }

        setTimeout(() => {
          window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        }, 0);
      }
    }
  );

  let lastStatus = {};

  const inputField = document.querySelector("#message_content");
  let typingTimeout;

  if (inputField) {
    inputField.addEventListener("input", () => {
      consultationChannel.send({ type: "typing", typing: true });

      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(() => {
        consultationChannel.send({ type: "typing", typing: false });
      }, 1500);
    });
  }

  //  function initWave(id) {
  //   if (!id || id === "undefined") {
  //     console.warn("[DEBUG] initWave skipped — invalid ID:", id);
  //     return;
  //   }

  //   console.log("[DEBUG] initWave called for ID:", id);

  //   const audioEl = document.getElementById(`audio-${id}`);
  //   const waveformEl = document.getElementById(`waveform-${id}`);
  //   const playBtn = document.querySelector(`.play-btn[data-id="${id}"]`);

  //   if (!audioEl || !waveformEl || !playBtn) {
  //     console.warn("[DEBUG] Missing audio/waveform/playBtn elements for ID:", id);
  //     return;
  //   }

  //   // 🧹 Очистити попередній waveform, якщо є
  //   waveformEl.innerHTML = "";

  //   const wavesurfer = WaveSurfer.create({
  //     container: waveformEl,
  //     waveColor: "#ddd",
  //     progressColor: "#4caf50",
  //     height: 35,
  //     responsive: true
  //   });

  //   wavesurfer.load(audioEl.src);

  //   const playIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="white"/><polygon points="12,8 24,16 12,24" fill="black"/></svg>`;
  //   const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><circle cx="16" cy="16" r="16" fill="white"/><rect x="10" y="8" width="4" height="16" fill="black"/><rect x="18" y="8" width="4" height="16" fill="black"/></svg>`;

  //   playBtn.innerHTML = playIcon;

  //   playBtn.addEventListener("click", () => {
  //     wavesurfer.playPause();
  //     playBtn.innerHTML = wavesurfer.isPlaying() ? pauseIcon : playIcon;
  //   });

  //   wavesurfer.on("finish", () => {
  //     playBtn.innerHTML = playIcon;
  //   });
  // }

});
